module.exports = __webpack_public_path__ + "static/media/gold_salary.cc5ef5fa.svg";